module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.9133/img/business-types/professional-service.png"